export class UserNotification {
    id: string;
    createDateTimeUtc: string;
    updateDateTimeUtc: string;
    message: string;
    type: NotificationType;
    status: NotificationStatus;
    link: string;
    recipientGroups: string[];
    acknowledgedUsers: string [];
}
export enum NotificationType {
    Null = 'Null',
    PartImport = 'Part Import',
    Alert = 'Alert',
    Vehicle = 'Vehicle',
    Sensor = 'Sensor',
    Group = 'Group',
    // Value must match the C# NotificationType member name: the contracts enum is serialized with
    // StringEnumConverter, so the wire value is the bare name 'AlertRuleBacktest'. #11219.
    AlertRuleBacktest = 'AlertRuleBacktest'
}
export enum NotificationStatus{
    Null = 'Null',
    New = 'New',
    InProgress = 'In Progress',
    Completed = 'Completed',
    Warning = 'Warning',
    Danger = 'Danger'
}
